<!-- หน้าเพิ่มคนไข -->
<template>
  <v-dialog v-model="dialog" persistent max-width="1000">
    <v-card>
      <v-card-title class="justify-space-between px-4 pb-0 pt-6">
        <v-btn icon disabled small><v-icon>mdi-clear</v-icon></v-btn>
        <span class="font-20 text-00a99d w-700">แบบฟอร์มลงทะเบียนผู้ป่วย</span>
        <v-btn icon color="#00a99d" @click="dialog = false" small><v-icon>mdi-close</v-icon></v-btn>
      </v-card-title>
      <v-card-text class="pb-4">
        <v-form ref="form_register" v-model="valid" lazy-validation>
          <v-expansion-panels flat v-model="panel" multiple>
            <v-expansion-panel :key="0">
              <v-expansion-panel-header class="px-0 py-0">
                <div class="d-flex align-center">
                  <span class="pr-5 text-00a99d w-500 font-18">ข้อมูลส่วนตัว</span>
                  <v-divider></v-divider>
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row>
                  <v-col cols="12" sm="6" md="6" xl="3" lg="3" class="pt-0">
                    <div class="d-flex flex-column">
                      <span>เพศ <span class="red--text">*</span></span>
                      <v-radio-group v-model="items.gender" row dense class="pa-0 mt-2" :readonly="view"
                        @change="genderChange" :rules="rules.rule_gender" required>
                        <v-radio label="ชาย" value="ชาย" color="#00a99d"></v-radio>
                        <v-radio label="หญิง" value="หญิง" color="#00a99d"></v-radio>
                      </v-radio-group>
                    </div>
                  </v-col>
                  <v-col cols="12" sm="6" md="6" xl="3" lg="3" class="pt-0">
                    <div class="d-flex flex-column">
                      <span> คำนำหน้า <span class="red--text">*</span> </span>
                      <v-select solo @input="titleChange()" v-model="items.account_title_th" :items="titleItems"
                        hide-details="auto" dense :menu-props="{ bottom: true, offsetY: true }" color="#00a99d"
                        placeholder="เลือกคำนำหน้าชื่อ" class="custom-text-field" :rules="rules.rule_account" required
                        item-color="teal darken-2"></v-select>
                    </div>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="6" md="6" xl="6" lg="6" class="pt-0">
                    <div class="d-flex flex-column">
                      <span>
                        ชื่อ (ภาษาไทย) <span class="red--text">*</span>
                      </span>
                      <v-text-field placeholder="ชื่อ (ภาษาไทย)" class="custom-text-field" solo hide-details="auto" dense :readonly="view"
                        v-model="items.first_name_th" :rules="rules.rule_name_th" required></v-text-field>
                    </div>
                  </v-col>
                  <v-col cols="12" sm="6" md="6" xl="6" lg="6" class="pt-0">
                    <div class="d-flex flex-column">
                      <span>
                        นามสกุล (ภาษาไทย) <span class="red--text">*</span>
                      </span>
                      <v-text-field placeholder="นามสกุล (ภาษาไทย)" class="custom-text-field" solo hide-details="auto" dense :readonly="view"
                        v-model="items.last_name_th" :rules="rules.rule_lastname_th" required></v-text-field>
                    </div>
                  </v-col>
                  <v-col cols="12" sm="6" md="6" xl="6" lg="6" class="pt-0">
                    <div class="d-flex flex-column">
                      <span>
                        ชื่อ (ภาษาอังกฤษ)
                      </span>
                      <v-text-field placeholder="ชื่อ (ภาษาอังกฤษ)" class="custom-text-field" solo hide-details="auto" dense :readonly="view"
                        v-model="items.first_name_eng"></v-text-field>
                      <!-- :rules="rules.rule_name_eng"
                        <span class="red--text">*</span> -->
                    </div>
                  </v-col>
                  <v-col cols="12" sm="6" md="6" xl="6" lg="6" class="pt-0">
                    <div class="d-flex flex-column">
                      <span>
                        นามสกุล (ภาษาอังกฤษ)
                      </span>
                      <v-text-field placeholder="นามสกุล (ภาษาอังกฤษ)" class="custom-text-field" solo hide-details="auto" dense :readonly="view"
                        v-model="items.last_name_eng"></v-text-field>
                      <!-- <span class="red--text">*</span>
                        :rules="rules.rule_lastname_eng" -->
                    </div>
                  </v-col>
                  <v-col cols="12">
                    <v-row>
                      <v-col cols="12" sm="6" md="6" xl="6" lg="6" class="py-0">
                        <span> ประเภทบัตร {{ displayIdCard(items.id_card_type) }} <span
                            class="red--text">*</span></span>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" sm="6" md="6" xl="6" lg="6" class="pt-0">
                        <v-select solo hide-details="auto" dense v-model="items.id_card_type" item-text="text"
                          item-value="value" :items="itemType" class="pr-1"
                          :menu-props="{ bottom: true, offsetY: true }" :rules="rules.rule_card_type" required
                          color="#00a99d" item-color="teal"></v-select>
                      </v-col>
                      <v-col cols="12" sm="6" md="6" xl="6" lg="6" class="pt-0">
                        <v-text-field placeholder="หมายเลขบัตรประชาชน" class="custom-text-field" solo hide-details="auto" dense
                          v-model="items.id_card_num" :readonly="view" :rules="rules.rule_card_num"
                          @keypress="validateNumber" @input="validateThaiIDCard" :error-messages="err_msg"
                          maxlength="13" required v-if="items.id_card_type == 'ID_CARD'"></v-text-field>
                        <v-text-field placeholder="หมายเลข PASSPORT" class="custom-text-field" solo hide-details="auto" dense
                          v-model="items.id_card_num" :readonly="view" :rules="rules.rule_passports" required
                          v-else></v-text-field>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="12" sm="6" md="6" xl="6" lg="6" class="pt-0">
                    <div class="d-flex flex-column">
                      <span>
                        วัน / เดือน / ปีเกิด <span class="red--text">*</span>
                      </span>
                      <v-menu :readonly="view" ref="birth_date" v-model="menubirth_date" :close-on-content-click="false"
                        :return-value.sync="items.birth_date" transition="scale-transition" offset-y min-width="auto">
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field placeholder="วัน / เดือน / ปีเกิด" class="custom-text-field" solo dense :value="formatBirthDate"
                            append-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" hide-details="auto" required
                            :rules="rules.rule_birth_date" color="#00a99d"></v-text-field>
                        </template>
                        <!-- :rules="rules.rule_birth_date"
                            <span class="red--text">*</span> -->
                        <v-date-picker ref="picker" v-model="items.birth_date" no-title scrollable :readonly="view"
                          :max="yearmax" locale="th" @input="calculateAge(items.birth_date)" color="#00a99d">
                          <v-spacer></v-spacer>
                          <v-btn text color="#00a99d" @click="cancel_birth()">
                            Cancel
                          </v-btn>
                          <v-btn text color="#00a99d" @click="calculateAge(items.birth_date)">
                            OK
                          </v-btn>
                        </v-date-picker>
                      </v-menu>
                    </div>
                  </v-col>
                  <v-col cols="12" sm="6" md="6" xl="6" lg="6" class="pt-0">
                    <div class="d-flex flex-column">
                      <span> อายุ</span>
                      <v-text-field placeholder="อายุ" class="custom-text-field" solo hide-details="auto" v-model="items.age" dense
                        readonly></v-text-field>
                    </div>
                  </v-col>
                  <v-col cols="12" sm="6" md="6" xl="6" lg="6" class="pt-0">
                    <div class="d-flex flex-column">
                      <span> หมู่เลือด </span>
                      <v-select placeholder="หมู่เลือด" class="custom-text-field" solo :items="blood_list" v-model="items.blood"
                        hide-details="auto" dense :readonly="view" :menu-props="{ bottom: true, offsetY: true }"
                        color="#00a99d" item-color="teal darken-2"></v-select>
                    </div>
                  </v-col>
                  <v-col cols="12" sm="6" md="6" xl="6" lg="6" class="pt-0">
                    <div class="d-flex flex-column">
                      <span>
                        หมายเลขโทรศัพท์ <span class="red--text">*</span>
                      </span>
                      <v-text-field placeholder="หมายเลขโทรศัพท์" class="custom-text-field" solo hide-details="auto" dense v-model="items.mobile"
                        :readonly="view" :rules="rules.rule_tel" required @keypress="validateNumber"
                        maxLength="10"></v-text-field>
                    </div>
                  </v-col>
                  <v-col cols="12" sm="6" md="6" xl="6" lg="6" class="pt-0">
                    <div class="d-flex flex-column">
                      <span>
                        Email (Email one)<span class="red--text" v-show="false">*</span>
                      </span>
                      <v-text-field placeholder="Email (Email one)" solo hide-details="auto" dense v-model="items.email"
                        :readonly="view" disabled class="disable-textfield custom-text-field"></v-text-field>
                    </div>
                  </v-col>
                  <v-col cols="12" sm="6" md="6" xl="6" lg="6" class="pt-0">
                    <div class="d-flex flex-column">
                      <span> HN </span>
                      <v-text-field placeholder="HN" class="custom-text-field" solo hide-details="auto" dense v-model="items.HN"
                        :readonly="view"></v-text-field>
                    </div>
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>

            <v-expansion-panel :key="1" class="mt-0">
              <v-expansion-panel-header class="px-0 py-0">
                <div class="d-flex align-center">
                  <span class="pr-5 text-00a99d w-500 font-18">ข้อมูลที่อยู่ตามทะเบียนราษฎร์</span>
                  <v-divider></v-divider>
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row>
                  <v-col cols="12" sm="4" md="4" xl="4" lg="4" class="pt-0">
                    <div class="d-flex flex-column">
                      <span> บ้านเลขที่</span>
                      <!-- <span class="red--text">*</span>  -->
                      <!-- :rules="rules.rule_house_no" -->
                      <v-text-field placeholder="บ้านเลขที่" class="custom-text-field" solo hide-details="auto" dense
                        v-model="items.address.house_no" :readonly="view" ></v-text-field>
                    </div>
                    <!-- <div class="px-3"></div> -->
                  </v-col>
                  <v-col cols="12" sm="4" md="4" xl="4" lg="4" class="pt-0">
                    <div class="d-flex flex-column">
                      <span> หมู่ </span>
                      <v-text-field placeholder="หมู่" class="custom-text-field" solo hide-details="auto" v-model="items.address.moo_no" dense
                        :readonly="view" ></v-text-field>
                    </div>
                  </v-col>
                  <v-col cols="12" sm="4" md="4" xl="4" lg="4" class="pt-0">
                    <div class="d-flex flex-column">
                      <span> ถนน / ซอย </span>
                      <v-text-field placeholder="ถนน / ซอย" class="custom-text-field" solo hide-details="auto" dense v-model="items.address.soi"
                        :readonly="view"></v-text-field>
                    </div>
                  </v-col>
                  <v-col cols="12" sm="4" md="4" xl="4" lg="4" class="pt-0">
                    <div class="d-flex flex-column">
                      <span> จังหวัด </span>
                      <!-- <span class="red--text">*</span>
                      :rules="rules.rule_province" -->
                      <v-autocomplete :items="set_province" item-value="province" item-text="province"
                        @input="getAmphoe('template')" :menu-props="{ bottom: true, offsetY: true }" solo dense
                        hide-details="auto" placeholder="กรุณาเลือกจังหวัด" class="custom-text-field" v-model="items.address.province"
                        item-color="teal darken-2" color="#00A99D" :readonly="view">
                        <template slot="no-data">
                          <span class="pl-2">ไม่มีข้อมูลจังหวัด</span>
                        </template>
                      </v-autocomplete>
                    </div>
                  </v-col>
                  <v-col cols="12" sm="4" md="4" xl="4" lg="4" class="pt-0">
                    <div class="d-flex flex-column">
                      <span> อำเภอ / เขต </span>
                      <!-- <span class="red--text">*</span>
                      :rules="rules.rule_amphur" -->
                      <v-autocomplete :items="set_amphoe" item-value="amphoe" item-text="amphoe"
                        @input="getTambon('template')" :menu-props="{ bottom: true, offsetY: true }" solo dense
                        hide-details="auto" placeholder="กรุณาเลือกอำเภอ/เขต" class="custom-text-field" v-model="items.address.amphur"
                        item-color="teal darken-2" color="#00A99D" :readonly="view">
                        <template slot="no-data">
                          <span class="pl-2">กรุณาเลือกจังหวัด</span>
                        </template>
                      </v-autocomplete>
                    </div>
                  </v-col>
                  <v-col cols="12" sm="4" md="4" xl="4" lg="4" class="pt-0">
                    <div class="d-flex flex-column">
                      <span> ตำบล / แขวง </span>
                      <!-- <span class="red--text">*</span>
                        :rules="rules.rule_tambon" -->
                      <v-autocomplete :items="set_tambon" item-value="tambon" item-text="tambon"
                        @change="getPostal($event)" :menu-props="{ bottom: true, offsetY: true }" solo dense
                        hide-details="auto" placeholder="กรุณาเลือกตำบล/แขวง" class="custom-text-field" v-model="items.address.tambon"
                        item-color="teal darken-2" color="#00A99D" :readonly="view">
                        <template slot="no-data">
                          <span class="pl-2">กรุณาเลือกอำเภอ</span>
                        </template>
                      </v-autocomplete>
                    </div>
                  </v-col>
                  <v-col cols="12" sm="4" md="4" xl="4" lg="4" class="pt-0">
                    <div class="d-flex flex-column">
                      <span>
                        รหัสไปรษณีย์
                      </span>
                      <!-- <span class="red--text">*</span>
                      :rules="rules.rule_zipcode" -->
                      <v-text-field placeholder="รหัสไปรษณีย์" class="custom-text-field" solo hide-details="auto" v-model="items.address.zipcode"
                        dense></v-text-field>
                    </div>
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>

            <v-expansion-panel :key="2" class="mt-0">
              <v-expansion-panel-header class="px-0 py-0">
                <div class="d-flex align-center">
                  <span class="pr-5 text-00a99d w-500 font-18">ข้อมูลสถานประกอบการ</span>
                  <v-divider></v-divider>
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row>
                  <v-col cols="12" sm="4" md="4" xl="4" lg="4" class="pt-0">
                    <div class="d-flex flex-column">
                      <span> สถานประกอบการ</span>
                      <v-text-field placeholder="ชื่อสถานประกอบการ" class="custom-text-field" solo hide-details="auto" dense v-model="items.company"
                        :readonly="view"></v-text-field>
                    </div>
                    <!-- <div class="px-3"></div> -->
                  </v-col>
                  <v-col cols="12" sm="4" md="4" xl="4" lg="4" class="pt-0">
                    <div class="d-flex flex-column">
                      <span> รหัสพนักงาน </span>
                      <v-text-field placeholder="รหัสพนักงาน" class="custom-text-field" solo hide-details="auto" dense v-model="items.employee_id"
                        :readonly="view"></v-text-field>
                    </div>
                    <!-- <span class="red--text">*</span>
                    :rules="rules.rule_employee_id" -->
                    <!-- <div class="px-3"></div> -->
                  </v-col>
                  <v-col cols="12" sm="4" md="4" xl="4" lg="4" class="pt-0">
                    <div class="d-flex flex-column">
                      <span> ตำแหน่ง </span>
                      <v-text-field placeholder="ตำแหน่ง" class="custom-text-field" solo hide-details="auto" dense v-model="items.position"
                        :readonly="view"></v-text-field>
                    </div>
                    <!-- <div class="px-3"></div> -->
                  </v-col>
                  <v-col cols="12" sm="4" md="4" xl="4" lg="4" class="pt-0">
                    <div class="d-flex flex-column">
                      <span> แผนก </span>
                      <v-text-field placeholder="แผนก" class="custom-text-field" solo hide-details="auto" v-model="items.department" dense
                        :readonly="view"></v-text-field>
                    </div>
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>

            <v-expansion-panel :key="3" class="mt-0">
              <v-expansion-panel-header class="px-0 py-0">
                <div class="d-flex align-center">
                  <span class="pr-5 text-00a99d w-500 font-18">ข้อมูลโรคประจำตัว</span>
                  <v-divider></v-divider>
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row>
                  <v-col cols="12" sm="4" md="4" xl="4" lg="4" class="pt-0">
                    <div class="d-flex flex-column">
                      <span>
                        โรคประจำตัว<span class="red--text" v-show="false">*</span>
                      </span>
                      <v-text-field placeholder="โรคประจำตัว" class="custom-text-field" solo hide-details="auto" dense
                        v-model="items.congenitalDisease" :readonly="view"></v-text-field>
                    </div>
                  </v-col>
                  <v-col cols="12" sm="4" md="4" xl="4" lg="4" class="pt-0">
                    <div class="d-flex flex-column">
                      <span>
                        แพ้ยา (ชื่อยา)<span class="red--text" v-show="false">*</span>
                      </span>
                      <v-text-field placeholder="แพ้ยา (ชื่อยา)" class="custom-text-field" solo hide-details="auto" dense
                        v-model="items.allergyDrug" :readonly="view"></v-text-field>
                    </div>
                  </v-col>
                  <v-col cols="12" sm="4" md="4" xl="4" lg="4" class="pt-0">
                    <div class="d-flex flex-column">
                      <span> อาการแพ้ยา <span class="red--text" v-show="false">*</span> </span>
                      <v-text-field placeholder="อาการแพ้ยา" class="custom-text-field" solo hide-details="auto" dense
                        v-model="items.allergyDrugDetail" :readonly="view"></v-text-field>
                    </div>
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
          <v-card-actions class="justify-center">
            <v-col cols="6" class="pr-2 pl-0"><v-btn block outlined rounded color="#00a99d"
                @click="dialog = false">ยกเลิก</v-btn></v-col>
            <v-col cols="6" class="pl-2 pr-0"><v-btn rounded block dark depressed color="#00a99d" :loading="btn_loading"
                type="submit" @click.prevent="clickConfirmed()">ยืนยัน</v-btn></v-col>
          </v-card-actions>
        </v-form>
        <!-- <v-btn @click="test">test</v-btn> -->
        <!-- <pre>{{ items }}</pre> -->
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import moment from "moment";
import functioncryto from "@/services/encrypt.js";
export default {
  data() {
    return {
      dialog: false,
      btn_loading: false,
      panel: [0, 1, 2],
      set_province: [],
      set_amphoe: [],
      set_tambon: [],
      edit: false,
      valid: false,
      view: false,
      menubirth_date: false,
      yearmax: "",
      findHis: "",

      items: {
        age: "",
        mobile: "",
        id_card_type: "ID_CARD",
        id_card_num: "",
        address: {
          house_no: "",
          moo_no: "",
          soi: "",
          province: "",
          amphur: "",
          tambon: "",
          zipcode: "",
        },
        email: "",
        account_title_th: "",
        account_title_eng: "",
        first_name_eng: "",
        first_name_th: "",
        last_name_eng: "",
        last_name_th: "",
        birth_date: "",
        gender: "",
        blood: "",
        HN: "",
        hos_code: "",
        _id: "",
      },
      titleItems: ["เด็กหญิง", "เด็กชาย", "นางสาว", "นาย", "นาง"],
      blood_list: ["A", "B", "O", "AB"],
      itemType: [
        { value: "ID_CARD", text: "บัตรประชาชน" },
        { value: "PASSPORT", text: "PASSPORT" },
      ],
      rules: {
        rule_gender: [(v) => !!v || "กรุณาเลือกเพศ"],
        rule_account: [(v) => !!v || "กรุณาเลือกคำนำหน้าชื่อ"],
        rule_name_th: [
          (v) => !!v || "กรุณากรอกชื่อ (ภาษาไทย)",
          (v) => !/^\s+|\s+$|\s{2,}/.test(v) || "กรุณากรอกชื่อ (ภาษาไทย)",
          (v) => /^[ก-๙\s]+$/.test(v) || "กรอกได้เฉพาะภาษาไทย",
        ],
        rule_lastname_th: [
          (v) => !!v || "กรุณากรอกนามสกุล (ภาษาไทย)",
          (v) => !/^\s+|\s+$|\s{2,}/.test(v) || "กรุณากรอกนามสกุล (ภาษาไทย)",
          (v) => /^[ก-๙\s]+$/.test(v) || "กรอกได้เฉพาะภาษาไทย",
        ],
        rule_name_eng: [
          (v) => !!v || "กรุณากรอกชื่อ (ภาษาอังกฤษ)",
          (v) => !/^\s+|\s+$|\s{2,}/.test(v) || "กรุณากรอกชื่อ (ภาษาอังกฤษ)",
          (v) => /^[a-zA-Z\s]+$/.test(v) || "กรอกได้เฉพาะภาษาอังกฤษ",
        ],
        rule_lastname_eng: [
          (v) => !!v || "กรุณากรอกนามสกุล (ภาษาอังกฤษ)",
          (v) => !/^\s+|\s+$|\s{2,}/.test(v) || "กรุณากรอกนามสกุล (ภาษาอังกฤษ)",
          (v) => /^[a-zA-Z\s]+$/.test(v) || "กรอกได้เฉพาะภาษาอังกฤษ",
        ],
        rule_card_type: [(v) => !!v || "กรุณาเลือกประเภทบัตร"],
        rule_card_num: [
          (v) => !!v || "กรุณากรอกหมายเลขบัตร",
          (v) => /^([0-9])+$/.test(v) || "กรอกได้เฉพาะตัวเลข",
          (v) => v.length === 13 || "กรอก 13 หลัก",
        ],
        rule_passports: [
          (v) => !!v || "กรุณากรอกหมายเลข Passport",
          (v) => /^\S+$/.test(v) || "กรุณากรอกหมายเลข Passport",
        ],
        rule_birth_date: [(v) => !!v || "กรุณาเลือกวันเกิด"],
        rule_tel: [
          (v) => !!v || "กรุณากรอกหมายเลขโทรศัพท์",
          (v) => /^([0-9])+$/.test(v) || "กรอกได้เฉพาะตัวเลข",
          (v) => v.length === 9 || v.length === 10 || "กรอก 9-10 หลัก",
        ],
        rule_house_no: [
          (v) => !!v || "กรุณากรอกบ้านเลขที่",
          (v) => /^\S+$/.test(v) || "กรุณากรอกบ้านเลขที่",
          (v) => /^[0-9]+(\/[0-9]+)?$/.test(v) || "กรอกได้เฉพาะตัวเลข",
        ],
        rule_province: [(v) => !!v || "กรุณาเลือกจังหวัด"],
        rule_amphur: [(v) => !!v || "กรุณาเลือกอำเภอ"],
        rule_tambon: [(v) => !!v || "กรุณาเลือกตำบล"],
        rule_zipcode: [(v) => !!v || "กรุณากรอกรหัสไปรษณีย์"],
      },
      err_msg: "",
    };
  },
  computed: {
    formatBirthDate() {
      var year1 = "";
      var year2 = "";
      if (this.items.birth_date === undefined || this.items.birth_date === "")
        return "";
      year1 = moment(this.items.birth_date).locale("th").format("YYYY");
      year2 = (parseInt(year1) + 543).toString();
      return moment(this.items.birth_date)
        .locale("th")
        .format("DD/MM/" + year2);
    },
  },
  watch: {
    menubirth_date(val) {
      val &&
        this.$nextTick(() => (this.$refs.picker.internalActivePicker = "YEAR"));
    },
  },
  async created() {
    await this.getProvince();
    await this.getHoscode();
    var now_date = new Date();
    this.yearmax = now_date.getFullYear() - 7 + "-" + 12 + "-" + 31;
  },
  methods: {
    openDialog() {
      try {
        this.items = {
          age: "",
          mobile: "",
          id_card_type: "ID_CARD",
          id_card_num: "",
          address: {
            house_no: "",
            moo_no: "",
            soi: "",
            province: "",
            amphur: "",
            tambon: "",
            zipcode: "",
          },
          company: "",
          department: "",
          employee_id: "",
          position: "",
          email: "",
          account_title_th: "",
          account_title_eng: "",
          first_name_eng: "",
          first_name_th: "",
          last_name_eng: "",
          last_name_th: "",
          birth_date: "",
          gender: "",
          blood: "",
          HN: "",
          hos_code: "",
          allergyDrug: "",
          allergyDrugDetail: "",
          congenitalDisease: "",
        };
        this.$refs.form_register.resetValidation();
        this.dialog = true;
        setTimeout(() => {
          document.getElementsByClassName('v-dialog--active')[0].scrollTop = 0
        }, 100)
      } catch {
        this.dialog = true;
        setTimeout(() => {
          document.getElementsByClassName('v-dialog--active')[0].scrollTop = 0
        }, 100)
      }
    },
    async getProvince() {
      try {
        this.items.address.zipcode = "";
        await this.axios
          .get(`${process.env.VUE_APP_BACKEND_URL}/province`)
          .then((res) => {
            if (res.status == 200) {
              this.set_province = res.data.data;
            }
          });
      } catch (err) {
        console.log(err);
        this.$swal({
          title:
            "<span style='color: black;font-size: 18px;font-family: Sarabun, sans-serif;'>เกิดข้อผิดผลาด</span>",
          icon: "error",
          showCloseButton: false,
          showConfirmButton: false,
          background: "white",
          timer: 3000,
        });
      }
    },
    async getAmphoe(from) {
      try {
        this.items.address.zipcode = "";
        await this.axios
          .get(
            `${process.env.VUE_APP_BACKEND_URL}/province/amphoe/${this.items.address.province}`
          )
          .then((res) => {
            if (res.status == 200) {
              if (this.items.address.province == "ฉะเชิงเทรา") {
                var arr = res.data.filter((ele) => {
                  return ele.amphoe !== "บางประกง";
                });
                this.set_amphoe = arr;
              } else {
                this.set_amphoe = res.data.data;
              }

              if (from == "template") {
                this.items.address.amphur = "";
                this.items.address.tambon = "";
              } else if (from == "api") {
                if (this.items.address.amphur) {
                  this.getTambon("api");
                } else {
                  this.items.address.tambon = "";
                }
              }
            }
          });
      } catch (err) {
        console.log(err);
        this.$swal({
          title:
            "<span style='color: black;font-size: 18px;font-family: Sarabun, sans-serif;'>เกิดข้อผิดผลาด</span>",
          icon: "error",
          showCloseButton: false,
          showConfirmButton: false,
          background: "white",
          timer: 3000,
        });
      }
    },
    async getTambon(from) {
      try {
        this.items.address.zipcode = "";
        await this.axios
          .get(
            `${process.env.VUE_APP_BACKEND_URL}/province/amphoe/tambon/${this.items.address.province}/${this.items.address.amphur}`
          )
          .then(async (res) => {
            if (res.status == 200) {
              if (from == "template") {
                if (this.items.address.amphur == "เมืองหนองคาย") {
                  for (let i of res.data) {
                    if (i.tambon === "สองห้อง") {
                      i.tambon = "โพนสว่าง";
                    }
                  }
                  this.set_tambon = res.data.data;
                } else {
                  this.set_tambon = res.data.data;
                }
              } else if (from == "api") {
                if (this.items.address.amphur == "เมืองหนองคาย") {
                  for (let i of res.data) {
                    if (i.tambon === "สองห้อง") {
                      i.tambon = "โพนสว่าง";
                    }
                  }
                  this.set_tambon = res.data.data;
                } else {
                  this.set_tambon = res.data.data;
                }
                await this.getPostal(this.items.address.tambon);
              }
            }
          });
      } catch (err) {
        console.log(err);
        this.$swal({
          title:
            "<span style='color: black;font-size: 18px;font-family: Sarabun, sans-serif;'>เกิดข้อผิดผลาด</span>",
          icon: "error",
          showCloseButton: false,
          showConfirmButton: false,
          background: "white",
          timer: 3000,
        });
      }
    },
    async getPostal(e) {
      var postal = await this.set_tambon.find((ele) => {
        return ele.tambon === e;
      });

      if (postal !== undefined) {
        this.items.address.zipcode = postal.zipcode;
      } else {
        this.items.address.zipcode = "";
      }
    },
    genderChange() {
      if (this.items.age) {
        switch (this.items.gender) {
          case "ชาย":
            if (this.items.age <= 14) {
              this.items.account_title_th = "เด็กชาย";
              this.items.account_title_eng = "Mr";
              this.titleItems = ["เด็กชาย"];
            } else if (this.items.age > 14) {
              this.items.account_title_th = "นาย";
              this.items.account_title_eng = "Mr";
              this.titleItems = ["นาย"];
            } else {
              this.items.account_title_eng = "Mr";
              this.titleItems = ["เด็กชาย", "นาย"];
            }
            break;
          case "หญิง":
            if (this.items.age <= 14) {
              this.items.account_title_th = "เด็กหญิง";
              this.items.account_title_eng = "Miss";
              this.titleItems = ["เด็กหญิง"];
            } else if (this.items.age > 14) {
              this.items.account_title_th = "นางสาว";
              this.items.account_title_eng = "Miss";
              this.titleItems = ["นางสาว", "นาง"];
            } else {
              this.items.account_title_eng = "Miss";
              this.titleItems = ["เด็กหญิง", "นางสาว", "นาง"];
            }
            break;
          default:
            break;
        }
      } else {
        if (this.items.gender === "ชาย") {
          this.items.account_title_th = "เด็กชาย";
          this.items.account_title_eng = "Mr";
          this.titleItems = ["เด็กชาย", "นาย"];
        }
        if (this.items.gender === "หญิง") {
          this.items.account_title_th = "เด็กหญิง";
          this.items.account_title_eng = "Miss";
          this.titleItems = ["เด็กหญิง", "นางสาว", "นาง"];
        }
      }
    },

    titleChange(age) {
      const hasAge = age || this.items.age;

      if (hasAge) {
        switch (true) {
          case (this.items.account_title_th === "นาย" ||
            this.items.account_title_th === "เด็กชาย") &&
            age <= 14:
            this.items.gender = "ชาย";
            this.items.account_title_th = "เด็กชาย";
            this.titleItems = ["เด็กชาย"];
            break;
          case (this.items.account_title_th === "นาย" ||
            this.items.account_title_th === "เด็กชาย") &&
            age > 14:
            this.items.gender = "ชาย";
            this.items.account_title_th = "นาย";
            this.titleItems = ["นาย"];
            break;
          case (this.items.account_title_th === "นาง" ||
            this.items.account_title_th === "นางสาว" ||
            this.items.account_title_th === "เด็กหญิง") &&
            age <= 14:
            this.items.gender = "หญิง";
            this.items.account_title_th = "เด็กหญิง";
            this.titleItems = ["เด็กหญิง"];
            break;
          case (this.items.account_title_th === "นาง" ||
            this.items.account_title_th === "นางสาว" ||
            this.items.account_title_th === "เด็กหญิง") &&
            age > 14:
            this.items.gender = "หญิง";
            if (this.items.account_title_th === "นาง") {
              this.items.account_title_th = "นาง";
            } else {
              this.items.account_title_th = "นางสาว";
            }
            this.titleItems = ["นางสาว", "นาง"];
            break;
          default:
            break;
        }
      } else {
        if (
          this.items.account_title_th === "นาย" ||
          this.items.account_title_th === "เด็กชาย" ||
          this.items.gender === "ชาย"
        ) {
          this.items.gender = "ชาย";
          this.titleItems = ["เด็กชาย", "นาย"];
        }
        if (
          this.items.account_title_th === "นาง" ||
          this.items.account_title_th === "นางสาว" ||
          this.items.account_title_th === "เด็กหญิง" ||
          this.items.gender === "หญิง"
        ) {
          this.items.gender = "หญิง";
          this.titleItems = ["เด็กหญิง", "นางสาว", "นาง"];
        }
      }
    },
    displayIdCard(idcard) {
      if (idcard === "" || idcard === undefined) return "หมายเลขบัตรประชาชน";
      if (idcard === "PASSPORT") return "PASSPORT";
      return "หมายเลขบัตรประชาชน";
    },
    calculateAge(date) {
      if (date) {
        this.menubirth_date = false;
        this.$refs.birth_date.save(date);
        const y = Math.floor(moment.duration(moment().diff(date)).asYears());
        this.items.age = y.toString();
        this.titleChange(this.items.age);
      }
    },
    async getHoscode() {
      try {
        const { data: { data } = {} } = await this.axios.get(
          `https://qr-tele.manageai.co.th/api/v1/bizid/hospital/getall?is_deleted=0`,
          {
            headers: {
              Authorization:
                "Bearer eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOjE3MzUzNzE4NzEsImlhdCI6MTcwNDI2Nzg3MSwibmJmIjoxNzA0MjY3ODcxLCJyZWYiOjAsInN1YiI6ImQ4ZDZjZDlhLWNmZjktNDI4Yi05NGFlLWY1ZGZiMWU2OTRkNiJ9.dAsuJepoiD703rSIlV0LeJzoMerdNfuShq3ZFFXX1auJWtWZsAZ80vgG6oP5qdix3n90lHoxn-TzrK4l-7qWpg",
            },
          }
        );
        const ov_code = data.find(
          (element) => element.business_id == sessionStorage.biz_id
        );
        if (ov_code) {
          this.findHis = ov_code.hospital_code;
        } else {
          this.findHis = "";
        }
        // console.log("🚀 ~ file: Dashboard.vue:1193 ~ getHoscode ~ data:",data.find(
        //   (element) => element.business_id == sessionStorage.biz_id
        // ));
      } catch (error) {
        console.error();
      }
    },
    cancel_birth() {
      this.menubirth_date = false;
      this.$refs.birth_date.save("");
      this.items.age = "";
    },
    clickConfirmed() {
      try {
        if (this.$refs.form_register.validate() && this.err_msg == "") {
        this.btn_loading = true;
        let cid_value = functioncryto.encrypt(this.items.id_card_num);
        let data = {
          // oneid: sessionStorage.oneId ? sessionStorage.oneId : null,
          one_id: null,
          // accountId: sessionStorage.account_id ? sessionStorage.account_id : null,
          account_id: null,
          account_title_th: this.items.account_title_th,
          account_title_eng: this.items.account_title_eng,
          cid: cid_value,
          first_name_eng: this.items.first_name_eng,
          first_name_th: this.items.first_name_th,
          last_name_eng: this.items.last_name_eng,
          last_name_th: this.items.last_name_th,
          mobile: this.items.mobile,
          birth_date: this.items.birth_date,
          biz_id: sessionStorage.biz_id ? sessionStorage.biz_id : null,
          id_card_type: this.items.id_card_type,
          id_card_num: this.items.id_card_num, //
          hospital_code: this.findHis || null,
          hos_code: this.findHis || null,
          email: this.items.email, //
          address: [
            {
              houseNo: this.items.address.house_no,
              moo: this.items.address.moo_no,
              soi: this.items.address.soi,
              amphur: this.items.address.amphur,
              tambon: this.items.address.tambon,
              province: this.items.address.province,
              zipcode: this.items.address.zipcode,
              official: true,
              default: true,
            },
          ],
          employee_id: this.items.employee_id,
          company: this.items.company,
          position: this.items.position,
          department: this.items.department,
          blood: this.items.blood,
          HN: this.items.HN,
          allergyDrug: this.items.allergyDrug, //
          allergyDrugDetail: this.items.allergyDrugDetail, //
          congenitalDisease: this.items.congenitalDisease, //
          gender: this.items.gender,
          user_create: sessionStorage.account_id
        };
        this.axios
          .post(`${process.env.VUE_APP_BACKEND_URL}/v1/user-qr`, data)
          .then((res) => {
            if (res.status == 200 && res.data) {
              this.$swal.fire({
                icon: "success",
                title: "สำเร็จ",
                timer: 3000,
                showConfirmButton: false,
                showCloseButton: false,
              });
              this.dialog = false;
              this.btn_loading = false;
              this.$emit("addPatient");
            }
          }).catch((err) => {
            console.log(err);
            this.btn_loading = false;
            if (
              err.response &&
              err.response.status === 500 &&
              err.response.data.message == "id card number already exists"
            ) {
              this.$swal.fire({
                icon: "warning",
                html: `
              <span style="color: black; font-size: 24px; font-family: Sarabun, sans-serif;">
                <strong>ไม่สามารถลงทะเบียนได้</strong>
              </span><br><br>
              <span style="color: black; font-size: 20px; font-family: Sarabun, sans-serif; padding-bottom: 14px; display: inline-block;">
                เนื่องจากเลขบัตรนี้มีอยู่ในระบบแล้ว
              </span>
              `,
                timer: 4000,
                showConfirmButton: false,
                showCloseButton: false,
              });
            }
          });
        }
      } catch (err) {
        console.log("🚀 ~ clickConfirmed ~ err:", err.message)
      }
    },
    validateNumber: (event) => {
      const keyCode = event.keyCode;
      if (keyCode < 48 || keyCode > 57) {
        event.preventDefault();
      }
    },
    validateThaiIDCard() {
      // ตรวจสอบเลขประจำตัวประชาชน
      var sum = 0;
      for (var i = 0; i < 12; i++) {
        sum += parseInt(this.items.id_card_num.charAt(i)) * (13 - i);
      }

      // ตรวจสอบเลขความถูกต้อง (Check Digit)
      if (
        (11 - (sum % 11)) % 10 !==
        parseInt(this.items.id_card_num.charAt(12))
      ) {
        this.err_msg = "รูปแบบเลขประจำตัวประชาชนไม่ถูกต้อง";
      } else {
        this.err_msg = "";
      }
    },
  },
};
</script>

<style scoped>
::v-deep .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)>.v-input__control>.v-input__slot {
  border: 1px solid #e8e9e9;
  box-sizing: border-box;
  border-radius: 6px;
  box-shadow: none;
}

::v-deep .disable-textfield>.v-input__control>.v-input__slot {
  background: #e8e9e9 !important;
}

::v-deep .v-input input {
  line-height: 1.8rem;
  text-indent: 4px;
}
::v-deep .v-list-item .v-list-item__title,
.v-list-item .v-list-item__subtitle {
  line-height: 1.8rem !important;
}

::v-deep
  .v-select
  .v-input__control
  .v-input__slot
  .v-select__slot
  .v-select__selections {
  line-height: 1.8rem;
}

.custom-text-field >>> input::placeholder {
  font-family: "TH SarabunPSK", "TH Sarabun New", sans-serif;
  font-size: 14px;
  font-weight: 200;
  color: #b6b6b6;
}
</style>
